// eslint-disable-next-line no-undef
import { buildItemTrackingData, setLocalStorageProperties, trackEvent, trackProductClick } from 'lib/tracking'

// eslint-disable-next-line no-undef
class ProductCard extends HTMLElement {
  constructor () {
    super()
    this.trackItem = this.trackItem.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  connectedCallback () {
    const dataElement = this.querySelector('[data-product]')
    if (dataElement) {
      this.product = JSON.parse(decodeURIComponent(dataElement.innerHTML.replace(/\+/g, ' ')))
    }
    this.initListeners()
  }

  initListeners () {
    this.querySelectorAll('a,button').forEach((el) => {
      el.addEventListener('click', this.trackItem)
    })
    this.querySelectorAll('[data-action]').forEach((el) => {
      el.addEventListener('click', this.handleClick)
    })
  }

  trackItem (e) {
    e.preventDefault()

    const otherData = {
      origin: document.body.dataset.origin,
      originProduct: document.body.dataset.originProduct,
      index: +this.getAttribute('data-index') + 1
    }
    const listData = {
      listName: this.getAttribute('data-parent') || undefined,
      navigationCategory: null,
      listId: this.getAttribute('data-list-type'),
      index: +this.getAttribute('data-index') + 1,
      moduleName: this.getAttribute('data-list-type')?.replace('-', ' ')
    }

    const payload = buildItemTrackingData(this.product, 1, otherData);
    setLocalStorageProperties(otherData, listData)
    trackProductClick('select_item', payload, listData);

    if (this.product.type === 'Bundle Builder') {
      trackEvent({
        event: 'select_bundle',
        site_section: window.__GLOBAL__.siteSection,
        component_name: 'Bundle Builder PLP Product Card',
        item_list_id: this.getAttribute('data-list-type'),
        item_list_name: this.getAttribute('data-parent') || undefined,
        bundle_type: 'bundle builder',
        bundle_name: this.product.title,
        bundle_id: Number(this.product.id),
        price: this.product.price / 100,
        currency: window.Shopify.currency.active,
        index: +this.getAttribute('data-index') + 1
      })
    }

    if (e.currentTarget.href) {
      window.location = e.currentTarget.href
    }
  }

  handleClick (e) {
    if (e.target?.dataset?.action === 'quick-shop') {
      return window.KENDO.openQuickModal(this.product)
    }
    if (e.target?.dataset?.action === 'notify') {
      return window.KENDO.openBackInStock({
        product: {
          id: this.product.id,
          title: this.product.title,
          price: this.product.price,
          featuredImage: this.product.featuredImage
        },
        variant: this.product.variants[0]
      })
    }
    if (e.target?.dataset?.action === 'add') {
      const properties = {
        _upsell_bundle: this.product.cart_upsell_bundle,
        _promo_text: this.product.promo_text,
        _promo_link: this.product.promo_link,
        _product_collection: this.product.categories ? this.product.categories[0] : null,
        _product_tags: this.product.tags,
        _product_rating: this.product.reviewsAverage,
        _item_list_name: this.getAttribute('data-parent') || '',
        _item_list_id: this.getAttribute('data-list-type'),
        _origin: document.body.dataset.origin,
        _origin_product: document.body.dataset.originProduct,
        _index: +this.getAttribute('data-index') + 1
      }
      return window.KENDO.addToCart(
        {
          id: this.product.variants?.[0]?.id,
          quantity: 1
        },
        +this.getAttribute('data-index'),
        properties
      )
    }
    window.location = this.product.url
  }
}

window.customElements.define('product-card-static', ProductCard)
